import React from "react";
import "./About.css";
import img from "../../image/img.jpg";

function About() {
  return (
    <>
      <div className="banner">
        <div className="image-container">
          <img src={img} alt="img" className="fixed-image" />
          <div className="text-overlay">
            <h1 className="fw-bold display-4">We are Astitva</h1>
            <p>
              India’s most reliable and lowest cost logistics service partner
            </p>
          </div>
        </div>
      </div>
      {/* ..../.... */}
     
    </>
  );
}

export default About;
